import {useSelector} from 'react-redux';

export function useEventNewsLoaded(eventId) {
    return useSelector(state => state.events[eventId]?.news?.loaded);
}
